import { objectSchema } from "vue-utils"
import type { IncidentEntity } from "./IncidentEntity"
import { UserTimeStamp } from "./UserTimeStamp"

export interface DocumentUpload extends IncidentEntity {
	fileName: string
	mimeType: string
	guid: string
	fileSize: number
	uploadedBy: UserTimeStamp
}

export const DocumentUpload = objectSchema<DocumentUpload>({
	id: Number,
	fileName: String,
	mimeType: String,
	guid: String,
	fileSize: Number,
	uploadedBy: UserTimeStamp,
})
